import { useState,useEffect } from '@wordpress/element';
import {ColorPalette } from '@wordpress/components';
import { VayuBlocksBlockEditor } from '@vayu-blocks/global';
import { Icon, brush } from '@wordpress/icons';

const VayuBlocksColors = (props) =>{  
    const { colorPanel,attributeKey, onChange} = props;
    const [ activeTab, setActiveTab ] = useState('color');
    const index = colorPanel.findIndex(item => item.key === attributeKey);
    const colorData = colorPanel[index];
    const blockEditor = VayuBlocksBlockEditor();
    const [colors, setColors] = useState([]);

    // default border colors
    useEffect(() => {
      setColors( [
        {
    colors: blockEditor.colors,
    name: 'THEME COLORS'
  },
  {
    colors:[
      {
        "name": "Black",
        "slug": "black",
        "color": "#000000"
      },
      {
        "name": "Cyan bluish gray",
        "slug": "cyan-bluish-gray",
        "color": "#abb8c3"
      },
      {
        "name": "White",
        "slug": "white",
        "color": "#ffffff"
      },
      {
        "name": "Pale pink",
        "slug": "pale-pink",
        "color": "#f78da7"
      },
      {
        "name": "Vivid red",
        "slug": "vivid-red",
        "color": "#cf2e2e"
      },
      {
        "name": "Luminous vivid orange",
        "slug": "luminous-vivid-orange",
        "color": "#ff6900"
      },
      {
        "name": "Luminous vivid amber",
        "slug": "luminous-vivid-amber",
        "color": "#fcb900"
      },
      {
        "name": "Light green cyan",
        "slug": "light-green-cyan",
        "color": "#7bdcb5"
      },
      {
        "name": "Vivid green cyan",
        "slug": "vivid-green-cyan",
        "color": "#00d084"
      },
      {
        "name": "Pale cyan blue",
        "slug": "pale-cyan-blue",
        "color": "#8ed1fc"
      },
      {
        "name": "Vivid cyan blue",
        "slug": "vivid-cyan-blue",
        "color": "#0693e3"
      },
      {
        "name": "Vivid purple",
        "slug": "vivid-purple",
        "color": "#9b51e0"
      }
    ],
    name: 'DEFAULT'
  }

]);
      }, [blockEditor]);

       
   


        
    const isHexColor = (str)=>{
        
      let haxColor =  /^#([0-9A-F]{3}){1,2}$/i.test(str);
      let gradient =  /^linear-gradient/.test(str);
      const isRadialGradient = /^radial-gradient/i.test(str);

      if (haxColor) {
          setActiveTab('color');
          
          }else if(gradient || isRadialGradient){
          setActiveTab(false);
          }

}


  const eyePickColor = async () => {
    if ('EyeDropper' in window) {
      try {
        const eyeDropper = new window.EyeDropper();
        const result = await eyeDropper.open();
        onChange(attributeKey,result.sRGBHex);
        // console.log(result.sRGBHex);
      } catch (err) {
        console.error('EyeDropper cancelled or failed:', err);
      }
    } else {
      alert('EyeDropper API is not supported in this browser.');
    }
  }

  useEffect(() => {
    isHexColor(colorData.value)
    }, [colorData]);

        return <>
        <Icon className="vb-eyedrop" icon={ brush } onClick={eyePickColor} title="eyeDrop"/>
          <ColorPalette
              colors={ colors }
              value={activeTab ? colorData.value : null}
              onChange={(value)=>onChange(attributeKey,value) }
              enableAlpha
              clearable={true}
          />
          </>
}

export default VayuBlocksColors; 